export const CONTACT_CONFIG = {
  // 👉 PASTE YOUR REAL WHATSAPP NUMBER HERE. International format, digits only, no "+".
  // Example for Miami: '13051234567'. While it has this value, the buttons will NOT work.
  WHATSAPP_NUMBER: 'WHATSAPP_AQUI',
  DEFAULT_MESSAGE: 'Hi iTranscorp, I need a quote to translate a document.',
  PHONE: '[PHONE HERE]',
  EMAIL: '[EMAIL HERE]',
  ADDRESS: 'Miami, FL [FULL ADDRESS HERE]',
  DELIVERY_TIME: '24 hours', // Confirmed by the user
  GUARANTEE: '[Acceptance or money-back guarantee]',
  ATA_MEMBER: '[ATA Member]',
  YEARS_EXP: '[X] years of experience',
}

// True until the user pastes a real number above.
export const isWhatsAppPlaceholder = !/^\d{8,15}$/.test(
  CONTACT_CONFIG.WHATSAPP_NUMBER,
)

export const getWhatsAppLink = (message = CONTACT_CONFIG.DEFAULT_MESSAGE) => {
  if (isWhatsAppPlaceholder) {
    // No real number yet: link is inert so visitors never hit a broken WhatsApp chat.
    return '#cotizar'
  }
  return `https://wa.me/${CONTACT_CONFIG.WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
}
